<template>

    <div class="colour-legend" :class="{'dark-mode': dark, 'light-mode':!dark}">
        <span v-for="(item, key) in items" v-bind:key="key" class="legend-item">
            <span class="colour-icon" :style="{backgroundColor:item.colour}"></span> {{ item.label }}
        </span>

    </div>

</template>

<script>
    //import $ from 'jquery';

    
    export default {
        name: 'ColourLegend',

        props: {
            items: {
                type: Array,
                default: null
            },
            dark: {
                type: Boolean,
                default: false
            },
        },
        data: function () {
            return {
                select2: null,
                currentOptions: this.options,
                currentValue: this.value
            }
        },
     
        methods: {

            

        },
        mounted: function() {

        },

    }
</script>

<style>
    .colour-icon {
        display: inline-block;
        width: 12px;
        height: 12px;
        border-radius: 50%;
    }

    .colour-legend {
        padding: 5px 10px;
        border-radius: 7px;
    }

    .legend-item {
        padding-right: 10px;
    }
    .dark-mode {
        background-color: rgba(0,0,0,0.5);
        color: white;
    }

    .light-mode {
        background-color: rgba(255,255,255,0.5);
        color: black;
    }
</style>